import { GeneralFieldController } from "./general-field-controller";
import { ControlState } from "../models/flexible/control-state";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";

export class InitialsFieldController extends GeneralFieldController {
	override useControlState(): ControlState {
		return this.parent.context.noPatients && this.parent.context.noPatients > 0 ? "hidden" : "enabled";
	}

	override mapInitialValue(value: unknown): unknown {
		return (
			value ||
			this.parent.context.startingPoint?.data[AttributeIdentifiers.Initials as any] ||
			""
		);
	}
}
